import { Text } from "@merge-api/merge-javascript-shared";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import MergeLogo from "./MergeLogo";

const PoweredByMerge = () => {
  const { shouldShowPoweredByMerge, translate } = useAgentHandlerLinkModalContext();

  if (!shouldShowPoweredByMerge) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-x-2 pt-1">
      <Text variant="md" className="text-gray-90">
        {translate("powered-by", "Powered by")}
      </Text>
      <MergeLogo color="black" />
    </div>
  );
};

export default PoweredByMerge;
